<template>
  <div>
    <div class="c-loading-spinner" v-if="isLoading"></div>
    <div class="c-loading-overlay" v-if="isLoading"></div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  isLoading: boolean
}>()
</script>
